export default {
  results: state => state
};
